import { render, staticRenderFns } from "./ElementsGallery.vue?vue&type=template&id=5bd61065&"
import script from "./ElementsGallery.vue?vue&type=script&lang=js&"
export * from "./ElementsGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports